<template>
  <div
    class="searchSelectText"
    :style="{ width: fieldProps.width ? `${fieldProps.width}px` : '200px' }"
  >
    <div class="searchSelectText-input">
      <a-input
        v-model="dateText"
        :placeholder="fieldProps.placeholder"
        :style="{ width: '100%' }"
        :allowClear="!fieldProps.hideClear"
        @change="onChange"
      />
    </div>
    <div class="searchSelectText-batch" v-if="isBatch">
      <a-popover trigger="click" v-model="visible" placement="bottomRight">
        <template slot="title">
          <div class="textarea-title">批量输入<span>(回车换行)</span></div>
        </template>
        <template slot="content">
          <div class="textarea-nav">
            <a-textarea
              :auto-size="{ minRows: 3 }"
              placeholder="批量输入，回车换行"
              v-model="dateTextarea"
            />
          </div>
          <div class="textarea-btn">
            <a-button size="small" @click="textareaCance()">清空</a-button>
            <a-button
              type="primary"
              class="btn-blue"
              size="small"
              @click="textareaOk()"
              >确定</a-button
            >
          </div>
        </template>
        <div class="text-batch">
          <a-icon type="file-add" />
        </div>
      </a-popover>
    </div>
  </div>
</template>
<script>
export default {
  name: "SearchText",
  props: {
    data: {
      type: String,
      default: "",
    },
    fieldProps: {
      type: Object,
      default: () => ({}),
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateTextarea: "",
      visible: false,
    };
  },
  computed: {
    // 查询参数
    dateText: function() {
      return JSON.parse(JSON.stringify(this.data));
    },
  },
  methods: {
    onChange(data) {
      this.$emit("changeBack", data.target.value);
    },

    textareaCance() {
      this.dateTextarea = "";
    },
    textareaOk() {
      console.log(this.dateTextarea);
      const newD = this.dateTextarea
        .split("\n")
        .filter(v => v)
        .map(k => k.replace(/^\s+|\s+$/g, ""));
      console.log(newD);
      this.visible = false;
      this.$emit("changeBack", newD.join(","));
    },
  },
};
</script>

<style lang="less" scoped></style>
